import { observer } from "mobx-react-lite";
import { Box, Button, Link, Typography } from "@mui/material";
import { StyledModal } from "./StyledModal";
import { ColumnBox } from "@root/components/common/ColumnBox";
import { ModalView } from "./common/ModalView";
import { useAccountContext } from "@root/stores/accountStore";

type SwitchToUserAccountModalProps = {
  open: boolean;
  onClose: () => void;
  onSwitched: () => void;
};

export const SwitchToUserAccountModal = observer(
  ({ open, onClose, onSwitched }: SwitchToUserAccountModalProps) => {
    const accountStore = useAccountContext();

    const handleSwitch = () => {
      const userProfile = accountStore.profiles.find((p) => p.type === "user");
      if (userProfile) {
        accountStore.switchProfile(userProfile);
        onSwitched();
      }
      onClose();
    };

    return (
      <StyledModal open={open} onClose={onClose}>
        <ColumnBox>
          <ModalView title="Switch to User Account">
            <Typography
              variant="body2"
              sx={{ textAlign: "center", whiteSpace: "pre-wrap", mb: 2 }}
            >
              Ticket booking is only available for personal user accounts.
              {"\n"}Please switch to your user account to book tickets for this event.
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: "2rem",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Link
                onClick={onClose}
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  fontWeight: 500,
                  textDecoration: "none",
                  cursor: "pointer",
                }}
              >
                Cancel
              </Link>
              <Button
                type="button"
                onClick={handleSwitch}
                sx={{ width: "fit-content" }}
              >
                Switch Account
              </Button>
            </Box>
          </ModalView>
        </ColumnBox>
      </StyledModal>
    );
  },
);
